import React, { Component } from 'react';
import Slider from 'rc-slider';

class AlphaSelector extends Component {

  constructor(props) {
    super(props);
    this.handleTextChange = this.handleTextChange.bind(this);
  }

  handleTextChange(e) {
    const value = parseInt(e.target.value.replace(/\D/g, ''), 10) / 100;
    this.props.onChange(value);
  }

  render() {
    const textValue = Math.ceil(this.props.value * 100) + '%';

    return (
      <div className="t-generic-slider">
        <div className="t-generic-slider-left">
          <Slider min={0} max={1.0} step={0.01} defaultValue={1.0} value={this.props.value} onChange={this.props.onChange} />
        </div>
        <div className="t-generic-slider-right">
          <input className="form-control" type="text" value={textValue} onChange={this.handleTextChange} />
        </div>

      </div>
    );
  }
}

export default AlphaSelector;


// WEBPACK FOOTER //
// ./src/components/AlphaSelector.js